import AbstractFigureModel from './AbstractFigureModel';
import { RenderNameProps } from '@widesk-ui/mixins/ApiModelRenderName';
import doc                 from '@widesk-core/decorators/doc';
import { Translatable }    from '@widesk-core/decorators/translatable';

@doc.urnResource('figure')
@doc.translatable({ biography: true, content: true })
class FigureModel extends AbstractFigureModel {
	public renderName(props?: RenderNameProps<this> & FigureNameProps) {
		return super.renderName(props);
	}
}

interface FigureModel
	extends Translatable<{ biography: true; content: true; }> {
}

export default FigureModel;